import { useContext } from 'react';
import { BPCChartsDataContext } from '../contexts/BPCChartsDataContext';

export const useBPCChartsDataContext = () => {
    return useContext(BPCChartsDataContext);
};
